import { CareerPathCompensation, CareerPathSampleJobs } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { CompensationTable } from './CompensationTable';
import { useAgentContext } from './EarningPotential.agentContext';
import { groupCompensationsByTrack } from '../util';

export function EarningPotential({
  careerPathCompensations,
  careerPathSampleJobs,
  careerPathName,
}: {
  careerPathCompensations: CareerPathCompensation[];
  careerPathSampleJobs: CareerPathSampleJobs;
  careerPathName: string;
}) {
  useAgentContext(careerPathCompensations, careerPathSampleJobs);

  const { careerTracks } = useAppSelector((state) => state.careerPath);
  const compensationsByTrack = groupCompensationsByTrack(careerPathCompensations, careerTracks);

  return (
    <CompensationTable
      data={compensationsByTrack}
      sampleJobs={careerPathSampleJobs}
      careerPathName={careerPathName}
    />
  );
}
